exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lightbox-security[data-v-28457e00]{padding:0 15px}.lightbox-security__inner[data-v-28457e00]{max-width:440px;margin:0 auto;padding:10px 15px;background-color:#fff}.lightbox-security__ttl[data-v-28457e00]{font-size:18px;font-size:1.8rem;font-weight:700;margin-bottom:20px}.lightbox-security__sentence[data-v-28457e00]{padding-top:15px;text-align:justify}.visa-amex[data-v-28457e00]{display:flex;justify-content:space-between;width:300px;margin:0 auto}.security-bottom[data-v-28457e00]{padding:20px 0 0;font-size:16px}.security-bottom a[data-v-28457e00]{color:#ff5b60;text-decoration:underline}.security-bottom a[data-v-28457e00]:hover{text-decoration:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-28457e00","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/lightbox/AboutSecurity.vue
// module id = 259
// module chunks = 0